import './Spinner.css';

// Small inline spinner for buttons/labels — an immediate, persistent in-progress
// indicator so no control ever sits idle while an API call is running.
export default function Spinner({ label }: { label?: string }) {
  return <span className="inline-spinner" role="status" aria-label={label || 'Working'} />;
}
